import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';
import { KOLKATANOWCAST_SOURCES, NOWCAST_SOURCES } from '../../nowcast/nowcast-map/nowcast-map-constants';

@Component({
  selector: 'app-kolkata-nowcast-sidebar',
  templateUrl: './kolkata-nowcast-sidebar.component.html',
  styleUrls: ['./kolkata-nowcast-sidebar.component.scss']
})
export class KolkataNowcastSidebarComponent implements OnInit {

  @Input() labelStrings: any;
  @Input() blockNum: number;
  @Output() playPos = new EventEmitter<any>();

  isInitialLoad: boolean = false;
  queryParams: {};
  selected: string;
  activeRadioList: boolean[] = [];
  dateIndexLength: number;
  sourceOptions: any;
  selectedSource: any;
  isSeamless: boolean = false
  disableUnitConversion: boolean = false;

  constructor(private gisUtils: UtilsService, private route: ActivatedRoute, private router: Router) {
    const url = this.router.url;
    const urlparams = url.split('/');
    this.selected = urlparams[2];
  }

  ngOnInit() {
    this.route.queryParamMap.subscribe((params: Params) => {
      this.queryParams = {};
      for (const param in params) {
        if (params.hasOwnProperty(param)) {
          this.queryParams = params[param];
        }
      }
      if (!isNullOrUndefined(this.queryParams) && Object.keys(this.queryParams).length > 0) {
        this.isInitialLoad = true
        this.dateIndexLength = 12
        this.sourceOptions = KOLKATANOWCAST_SOURCES['sourceList']
        this.selectedSource = this.queryParams['source']
        this.isSeamless = this.queryParams['seamlessView'] == 'true' ? true : false
        this.requestSelectedFilterParams()
      }
    })
  }

  ngOnChanges(change: SimpleChanges) {
    // let timeStamp = this.labelStrings[this.blockNum].groupName;
    // this.gisUtils.setTimeStamp(timeStamp)
    if (!isNullOrUndefined(change.blockNum) && Object.keys(this.labelStrings).length > 0) {
      // console.log("change.blockNum",change.blockNum);

      if (change.blockNum.currentValue) {
        this.buttonClicked(change.blockNum.currentValue);
      }

    } else {
      this.buttonClicked(this.blockNum);
    }
    const len = this.activeRadioList.length;
    this.activeRadioList = [];
    for (let i = 0; i < this.dateIndexLength; ++i) {
      if (i === this.blockNum) {
        this.activeRadioList.push(true);
      } else {
        this.activeRadioList.push(false);
      }
    }
  }

  buttonClicked(blockNumber, from?: string) {
    console.log("blockNum", this.blockNum);

    if (from === 'HTML') {
      this.playPos.emit(blockNumber);
    }
    this.gisUtils.setIndex(this.labelStrings[blockNumber]['groupName']);
  }

  validate(i) {
    if (this.labelStrings[i] == undefined || this.labelStrings[i] == null) {
      return ""
    }
    else {
      return this.labelStrings[i]['label']['label'];
    }
  }

  requestSelectedFilterParams() {
    let currentUrlParams: any = {};
    // if (!this.isInitialLoad) {
    //   currentUrlParams = this.selectedParams;
    // }
    currentUrlParams['component'] = 'KOLKATANOWCAST';
    currentUrlParams['src'] = 'IMD_GRID'
    if (this.isInitialLoad) {
      currentUrlParams['actionType'] = 'filter';
      currentUrlParams['view'] = 'ADMIN';
      currentUrlParams['pType'] = 'COUNTRY';
      currentUrlParams['cType'] = 'STATE';
      currentUrlParams['parentLoc'] = 'COUNTRY';
      currentUrlParams['dashboardView'] = 'INDIA';
      this.gisUtils.selectedParams.next(currentUrlParams);
      this.isInitialLoad = false
    }
  }

  sourceChange() {
    let options = { ...this.queryParams }
    options['source'] = this.selectedSource
    this.router.navigate(['/nowcastweather/kolkata-nowcast/akbm'], {
      relativeTo: this.route,
      queryParams: options,
      queryParamsHandling: 'merge'
    })
  }

  changeView(view?) {
    let options = { ...this.queryParams }
    options['seamlessView'] = this.isSeamless
    if (!this.isSeamless) {
      options['source'] = 'RADAR+CTT'
    }
    this.router.navigate(['.'], {
      relativeTo: this.route,
      queryParams: options,
      queryParamsHandling: 'merge'
    })
  }

}
